import React from 'react';

import { useRouter } from 'next/router';
import styles from './partner-pricing-banner.module.scss';
import { useFetchAffiliateData } from '../../../../hooks/useFetchAffiliateData';

type Props = {
  bannerText: string;
};

export const PartnerPricingBanner = ({ bannerText }: Props) => {
  const router = useRouter();

  const { isPromoProcessingCompleteWithoutErrors } = useFetchAffiliateData(
    router.query?.wacampaign as string,
  );

  if (!isPromoProcessingCompleteWithoutErrors) return null;

  return (
    <div className={styles.partnerPricingBannerRoot}>
      <span className={styles.promotionText}>{bannerText}</span>
    </div>
  );
};
